module.exports = __webpack_public_path__ + "img/vview.2df0f55a.jpg";